import { useEffect } from "react";

export const useUpdateDocTitle = (title: string): void => {
  useEffect(() => {
    if (title) {
      document.title = `${title} | FOND`;
    }
  }, [title]);
};
